module.exports = __webpack_public_path__ + "img/1-5.e5ad51cb.png";